import React from "react";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { teachersApi } from "../../services/teachers/teachersApi";
import Error from "../../components/common/Error";
import * as XLSX from "xlsx";

const TeachersReport: React.FC = () => {
  const { data: teachersReport, isLoading, error } = teachersApi.useGetTeachersReportQuery();

  const exportToExcel = () => {
    if (!teachersReport?.data) return;

    const exportData = teachersReport.data.map((teacher) => ({
      ИД: teacher.teacherId,
      Номер: teacher.teacherNumber,
      Име: teacher.firstName,
      Презиме: teacher.middleName,
      Фамилия: teacher.lastName,
      "Пълно име": teacher.fullName,
      "Име (EN)": teacher.firstNameEn,
      "Презиме (EN)": teacher.middleNameEn,
      "Фамилия (EN)": teacher.lastNameEn,
      ЕГН: teacher.egn,
      Имейл: teacher.email,
      Телефон: teacher.phone,
      Стая: teacher.room,
      Адрес: teacher.address,
      "Място на раждане": teacher.birthPlace,
      "Академична длъжност": teacher.academicPositionName,
      "Академично звание": teacher.academicRankName,
      Катедра: teacher.departmentName,
      Факултет: teacher.facultyName,
      Гражданство: teacher.citizenshipCountryName,
      Статус: teacher.teacherStatusName,
      Забележка: teacher.note,
      "Норма часове": teacher.normHours,
      "Дата на промяна": teacher.modifiedDate ? new Date(teacher.modifiedDate).toLocaleDateString("bg-BG") : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet["!autofilter"] = { ref: worksheet["!ref"] || "A1" };

    worksheet["!cols"] = [
      { wch: 8 }, // ИД
      { wch: 12 }, // Номер
      { wch: 15 }, // Име
      { wch: 15 }, // Презиме
      { wch: 15 }, // Фамилия
      { wch: 25 }, // Пълно име
      { wch: 15 }, // Име (EN)
      { wch: 15 }, // Презиме (EN)
      { wch: 15 }, // Фамилия (EN)
      { wch: 15 }, // ЕГН
      { wch: 25 }, // Имейл
      { wch: 15 }, // Телефон
      { wch: 10 }, // Стая
      { wch: 30 }, // Адрес
      { wch: 20 }, // Място на раждане
      { wch: 20 }, // Академична длъжност
      { wch: 20 }, // Академично звание
      { wch: 25 }, // Катедра
      { wch: 25 }, // Факултет
      { wch: 15 }, // Гражданство
      { wch: 15 }, // Статус
      { wch: 30 }, // Забележка
      { wch: 12 }, // Норма часове
      { wch: 15 }, // Дата на промяна
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Справка преподаватели");
    XLSX.writeFile(workbook, "справка-преподаватели.xlsx");
  };

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <div className="flex justify-content-center flex-wrap">
      <Card className="w-full mt-4">
        <div className="flex justify-content-between align-items-center">
          <h4>Справка: Преподаватели</h4>
          <Button
            icon="pi pi-file-excel"
            label="Експорт"
            className="p-button-success"
            onClick={exportToExcel}
            disabled={!teachersReport?.data || isLoading}
          />
        </div>
        <Divider />
        <div className="field col-12">
          <DataTable
            value={teachersReport?.data ?? []}
            emptyMessage="Няма намерени преподаватели."
            stripedRows
            paginator
            rows={10}
            rowsPerPageOptions={[10, 25, 50]}
            sortField="fullName"
            sortOrder={1}
          >
            <Column field="teacherNumber" header="Номер" sortable filter></Column>
            <Column field="fullName" header="Пълно име" sortable filter></Column>
            <Column field="egn" header="ЕГН" sortable filter></Column>
            <Column field="email" header="Имейл" sortable filter></Column>
            <Column field="phone" header="Телефон" sortable filter></Column>
            <Column field="room" header="Стая" sortable filter></Column>
            <Column field="academicPositionName" header="Академична длъжност" sortable filter></Column>
            <Column field="academicRankName" header="Академично звание" sortable filter></Column>
            <Column field="departmentName" header="Катедра" sortable filter></Column>
            <Column field="facultyName" header="Факултет" sortable filter></Column>
            <Column field="teacherStatusName" header="Статус" sortable filter></Column>
            <Column field="normHours" header="Норма часове" sortable filter></Column>
            <Column
              field="modifiedDate"
              header="Дата на промяна"
              sortable
              filter
              body={(rowData) =>
                rowData.modifiedDate ? new Date(rowData.modifiedDate).toLocaleDateString("bg-BG") : ""
              }
            ></Column>
          </DataTable>
        </div>
      </Card>
    </div>
  );
};

export default TeachersReport;
